import getApiClient from '@/plugins/api'

export default {
  loadReports: function (filter = null) {

    let params = {
      filter: filter?.target?.value ?? 'this_year'
    }

    this.loadPlacesReport(params)
    this.loadCategoriesReport(params)
    this.loadAgenciesReport(params)
    this.loadMonthsReport(params)
  },

  loadPlacesReport: function (params) {
    const self = this;
    const api = getApiClient(self.$root.$store);

    self.$store.commit('startLoading')

    api.get('places_reports', {params})
      .then((result) => {
        self.places = result.data['hydra:member']
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        self.$store.commit('stopLoading')
      })
  },

  loadCategoriesReport: function (params) {
    const self = this;
    const api = getApiClient(self.$root.$store);

    self.$store.commit('startLoading')

    api.get('categories_reports', {params})
      .then((result) => {
        self.categories = result.data['hydra:member']
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        self.$store.commit('stopLoading')
      })
  },

  loadAgenciesReport: function (params) {
    const self = this;
    const api = getApiClient(self.$root.$store);

    self.$store.commit('startLoading')

    api.get('agencies_reports', {params})
      .then((result) => {
        self.agencies = result.data['hydra:member']
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        self.$store.commit('stopLoading')
      })
  },

  loadMonthsReport: function (params) {
    const self = this;
    const api = getApiClient(self.$root.$store);

    self.$store.commit('startLoading')

    api.get('months_reports', {params})
      .then((result) => {
        self.months = result.data['hydra:member']
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        self.$store.commit('stopLoading')
      })
  }
}
